import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectCartCount } from 'store/selectors/cartSelectors';

import { Dialog, DialogPanel, Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import { IconX, IconAlignLeft, IconChevronDown } from '@tabler/icons-react';
import { FooterNavigation } from './DataMenu';
import Cart from './Cart';
import { signOutRequest } from 'store/actions/authActions';
import { menuItems } from 'lib/DefaultData';

const navigation = [
  // {
  //   name: 'Merchandise',
  //   submenu: null,
  //   url: '/merchandise',
  // },
  {
    name: 'Info & Price',
    submenu: [
      { name: 'Price Play', url: '/info-price#harga-tiket' },
      { name: 'Operational Hour', url: '/info-price#jam-operasional' },
      { name: 'Kin Thursday', url: '/info-price#kin-thursday' },
    ],
    url: '/info-price',
  },
  {
    name: 'Learning Space',
    submenu: [
      {
        name: 'Our Classes',
        url: '/learn/our-class',
      },
      {
        name: 'Class Schedule',
        url: '/learn/class-schedule',
      },
      {
        name: 'Class Passes',
        url: '/learn/class-pass',
      },
    ],
    url: '/learn/our-class',
  },
  {
    name: 'Exhibition',
    submenu: [
      { name: 'KiNSTALLATION', url: '/kinstallation' },
      { name: 'KiNTERACTIVE', url: '/kinteractive' },
    ],
    url: '/kinstallation',
  },
  {
    name: 'About',
    submenu: null,
    url: '/about',
  },
];

const HeaderPage = () => {
  const dispatch = useDispatch();
  const userProfile = useSelector((state) => state.authProfile);
  const cartCount = useSelector(selectCartCount);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const user = userProfile?.data ? userProfile?.data : null;

  const logout = () => {
    dispatch(signOutRequest());
    navigate('/login');
  };

  useEffect(() => {
    if (location.pathname === '/play') {
      navigate('/play/package-pass');
      setIsPopoverOpen(true);
    }
  }, [location, navigate]);

  const isActive = (href) =>
    location.pathname.includes(href) ? 'text-primary-main font-bold' : '';

  return (
    <header>
      <nav
        className="hidden md:flex items-center justify-between py-3 md:px-8 bg-kin-textsecondary"
        aria-label="Global">
        <div className="flex flex-1">
          <div className="hidden md:hidden md:gap-x-4 xl:flex xl:gap-x-4 items-center">
            {navigation.map((item, idx) => {
              if (item.submenu) {
                return (
                  <Popover className="relative" key={idx} open={isPopoverOpen}>
                    <PopoverButton className="inline-flex items-center gap-x-1 outline-none">
                      <span
                        className={`text-sm font-semibold leading-6 text-kin-text hover:text-kin-textdark hover:font-bold ${
                          isActive(item.url) ? 'text-primary-main' : 'text-kin-text'
                        }  font-bold`}>
                        {item.name}
                      </span>

                      <IconChevronDown
                        aria-hidden="true"
                        className={`h-5 w-5 ${
                          isActive(item.url) ? 'text-primary-main' : 'text-kin-text'
                        }`}
                      />
                    </PopoverButton>

                    <PopoverPanel
                      transition
                      className="absolute left-0 z-10 mt-1 flex transition data-[closed]:translate-y-1 data-[closed]:opacity-0 data-[enter]:duration-200 data-[leave]:duration-150 data-[enter]:ease-out data-[leave]:ease-in">
                      <div className="w-max shrink rounded-xl bg-white  text-sm/6 font-semibold text-gray-900 shadow-lg ring-1 ring-gray-900/5 overflow-hidden">
                        {item.submenu.map((submenuItem) => (
                          <a
                            key={submenuItem.name}
                            href={submenuItem.url}
                            className="block py-3 font-medium text-kin-text px-4 hover:bg-primary-main hover:text-white">
                            {submenuItem.name}
                          </a>
                        ))}
                      </div>
                    </PopoverPanel>
                  </Popover>
                );
              }

              return (
                <a
                  key={idx}
                  href={item.url}
                  className={`text-sm font-semibold leading-6 text-kin-text hover:text-kin-textdark hover:font-bold ${
                    isActive(item.url) ? 'text-primary-main' : 'text-kin-text'
                  }  font-bold`}>
                  {item.name}
                </a>
              );
            })}
          </div>
          <div className="flex xl:hidden">
            <button
              type="button"
              className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
              onClick={() => setMobileMenuOpen(true)}>
              <span className="sr-only">Open main menu</span>
              <IconAlignLeft className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
        </div>
        <a href="/" className="">
          <span className="sr-only">Your Company</span>
          <img className="h-9 w-auto" src="/kin/assest/logo.png" alt="" />
        </a>
        <div className="flex flex-1 justify-end">
          <div className="hidden md:flex md:gap-x-3 items-center">
            {/* <button type="button" onClick={() => setDrawerOpen(true)} className="relative">
              {cartCount > 0 && (
                <div className="rounded-full w-[16px] h-[16px] flex justify-center items-center bg-primary-main absolute -top-[5px] -right-[6px] z-[5]">
                  <span className="text-[12px] font-semibold text-white">{cartCount}</span>
                </div>
              )}

              <div className="w-6 h-6 relative cursor-pointer z-0">
                <img
                  alt="icon-cart"
                  src="/kin/assest/image/icon-cart.svg"
                  className="absolute inset-0 h-full w-full object-cover"
                />
              </div>
            </button> */}
            {!userProfile?.data ? (
              <div className="flex flex-row gap-x-3 items-center">
                {/* <div className="border-l border-kin-text mx-2 h-[20px]" /> */}
                <a href="/login">
                  <div className="text-kin-text text-sm font-semibold">Log In</div>
                </a>
                <a href="/register">
                  <button className="bg-primary-main text-white rounded-[100px] py-2 px-3 flex justify-center items-center">
                    <span className="text-xs font-semibold block">SIGN UP</span>
                  </button>
                </a>
              </div>
            ) : (
              <Popover className="relative">
                {({ open }) => (
                  <>
                    <PopoverButton className="flex flex-row items-center gap-x-3 outline-none ml-3">
                      <div className={`w-6 h-6 relative cursor-pointer z-0`}>
                        <img
                          alt="icon-default"
                          src={`${
                            open
                              ? '/kin/assest/image/user-icon-active.svg'
                              : '/kin/assest/image/user-icon.svg'
                          } `}
                          className="absolute inset-0 h-full w-full object-cover"
                        />
                      </div>
                      <span
                        className={`text-sm font-semibold leading-6 ${
                          open ? 'text-primary-main' : 'text-kin-text'
                        } hover:font-bold capitalize`}>
                        {user ? user.name : '-'}
                      </span>
                      <IconChevronDown
                        className={`${
                          open ? 'text-primary-main' : 'text-kin-text'
                        } text-kin-text h-5 w-5`}
                      />
                    </PopoverButton>
                    <PopoverPanel
                      transition
                      className="absolute right-0 z-10 mt-2.5 flex transition data-[closed]:translate-y-1 data-[closed]:opacity-0 data-[enter]:duration-200 data-[leave]:duration-150 data-[enter]:ease-out data-[leave]:ease-in">
                      <div className="w-max shrink rounded-xl bg-white  text-sm/6 font-semibold text-gray-900 shadow-lg ring-1 ring-gray-900/5 overflow-hidden">
                        {menuItems.map((item) => {
                          if (item.name === 'Log Out') {
                            return (
                              <button
                                onClick={() => logout()}
                                key={item.name}
                                className="w-full block py-3 font-normal text-kin-text px-4 hover:bg-primary-main hover:text-white text-left">
                                {item.name}
                              </button>
                            );
                          }

                          return (
                            <a
                              key={item.name}
                              href={item.url}
                              className="block py-3 font-normal text-kin-text px-4 hover:bg-primary-main hover:text-white">
                              {item.name}
                            </a>
                          );
                        })}
                      </div>
                    </PopoverPanel>
                  </>
                )}
              </Popover>
            )}
          </div>
        </div>
      </nav>
      {drawerOpen && <Cart drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />}
      <nav
        className="flex md:hidden items-center justify-between px-6 py-3 z-30 relative bg-kin-textsecondary"
        aria-label="Global">
        <a href="/" className="">
          <span className="sr-only">Your Company</span>
          <img className="h-9 w-auto" src="/kin/assest/svg-logo.svg" alt="" />
        </a>
        <div className="flex">
          <button
            type="button"
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-kin-text"
            onClick={() => setMobileMenuOpen(true)}>
            <span className="sr-only">Open main menu</span>
            <IconAlignLeft className="h-9 w-9" aria-hidden="true" />
          </button>
        </div>
      </nav>
      <Dialog className="xl:hidden" open={mobileMenuOpen} onClose={setMobileMenuOpen}>
        <div className="fixed inset-0 z-10" />
        <DialogPanel className="fixed top-0 left-0 right-0 z-30 w-full overflow-y-auto bg-primary-main px-6 pt-3 pb-8 rounded-br-[80px]">
          <div className="flex items-center justify-between">
            <a href="/" className="-m-1.5 p-1.5">
              <span className="sr-only">Your Company</span>
              <img className="h-9 w-auto" src="kin/assest/logo-svg.svg" alt="" />
            </a>
            <button
              type="button"
              className="-m-2.5 rounded-md p-2.5 text-kin-textsecondary"
              onClick={() => setMobileMenuOpen(false)}>
              <span className="sr-only">Close menu</span>
              <IconX className="h-9 w-9" aria-hidden="true" />
            </button>
          </div>
          <div className=" space-y-2 flex flex-col justify-center items-center">
            {navigation.map((item) => (
              <a
                key={item.name}
                href={item.url}
                className="font-sans block rounded-lg px-3 py-1 text-xl font-semibold leading-7 text-kin-textsecondary">
                {item.name}
              </a>
            ))}
          </div>
          <div className="flex flex-row justify-center items-center mt-8 gap-3 text-kin-textsecondary max-w-xs mx-auto">
            {FooterNavigation.social.map((item, idx) => (
              <a key={idx} href={item.url}>
                {item.icon_mobile}
              </a>
            ))}
          </div>
        </DialogPanel>
      </Dialog>
    </header>
  );
};

export default HeaderPage;
